export const selectCustomers = (state) => state?.opportunity?.customers?.data;
